import { useBlockProps } from '@wordpress/block-editor';
import { __ } from "@wordpress/i18n";

export default function Save({ attributes }) {
	const { showCalendar, showCards, showList, showSearch, showMap, eventsPerPage } = attributes;

	return (
		<div
			{...useBlockProps.save({
				'data-show-calendar': String(showCalendar),
				'data-show-cards': String(showCards),
				'data-show-list': String(showList),
				'data-show-search': String(showSearch),
				'data-show-map': String(showMap),

				'data-events-per-page': Number(eventsPerPage)
			})}
		>
		</div>
	);
}
